// @ts-nocheck
/* eslint-disable */
export const stdAddSelectionIcon = {
    data: `<?xml version="1.0" encoding="UTF-8"?><svg stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor"><path d="M8 12h4m4 0h-4m0 0V8m0 4v4M7 4H4v3M4 11v2M11 4h2M11 20h2M20 11v2M17 4h3v3M7 20H4v-3M17 20h3v-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'add-selection' as const
};